import React from 'react';
import PropTypes from 'prop-types';

const ArrowUp = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg id="angle-up" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" {...other}>
      <path id="Shape" d="M0,20H20V0H0Z" fill="none" />
      <path id="Path_5269" data-name="Path 5269" d="M16.371,15.8,10.288,9.638,4.2,15.8a1.159,1.159,0,0,1-1.583,0l-.583-.583a1.159,1.159,0,0,1,0-1.583l7.5-7.5a1.159,1.159,0,0,1,1.583,0l7.5,7.5a1.159,1.159,0,0,1,0,1.583l-.583.583A1.267,1.267,0,0,1,16.371,15.8Z" transform="translate(-0.288 -0.971)" fill={color} />
    </svg>
  );
}

ArrowUp.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

ArrowUp.defaultProps = {
  color: '#6a728a',
  width: 20,
  height: 20,
};

export default ArrowUp;





// WEBPACK FOOTER //
// ./src/components/Icons/ArrowUp.jsx